export default {
	props: {
		room_id: Number,
		rate_id: Number,
		max_room_qty: Number,
		max_adults: Number,
		children_on_bed: Object,
		children_no_bed: Object,
		num_nights: Number,
		currency: String,
		precision: {type:Number, default: 0},
		value:{type:Array, default:()=>([])},
	},
	data(){
		return {
			innerValue: null,
			selectedRoomsQty: null,
			onInputDebounce: getDebounceFunc(()=>{ this.$emit('change', this.innerValue); }),
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(v,o){
				this.innerValue = this.value ? this.value : [];
			},
		},
		innerValue:{
			immediate: true,
			handler(v, o){
				this.selectedRoomsQty = Object.values(this.innerValue).length;
			}
		},
		selectedRoomsQty:{
			handler(v,o){
				if(!this.selectedRoomsQty){
					this.$emit('delete');
				}
				else if(this.innerValue.length<this.selectedRoomsQty) {
					for(let i=this.innerValue.length;i<this.selectedRoomsQty;i++){
						this.$set(this.innerValue, i, {});
					}
				}
				else if(this.innerValue.length>this.selectedRoomsQty){
					this.innerValue.splice(this.selectedRoomsQty, this.innerValue.length-this.selectedRoomsQty);
				}
			},
		}
	},

	computed:{
		cp_roomQtyOptions(){
			let restRoomQty = this.max_room_qty - this.$root.getSelectedRoomQty(this.room_id) + this.selectedRoomsQty;
			let options = [];
			for(let i=1;i<=restRoomQty;i++){
				options.push({label:this.$tc('numRooms', i), value:i});
			}
			return options;
		},
	},
	methods: {
		onDeleteRoom(i){
			this.innerValue.splice(i,1);
			this.onInputDebounce();
		}
	},
	template: `
<div class="manual-select-rooms">
	<div class="msr-row">
		<div class="col1">
			{{$t('manualSelectRooms')}}
		</div>
		<div class="col2">
			<qit-select
				class="v3"
				:label="$t('selectNumRooms')"
				:label-value="0"
				:options="cp_roomQtyOptions"
				:disabled="Object.values(cp_roomQtyOptions).length==0"
				v-model="selectedRoomsQty"
				clearable
			/>
		</div>
	</div>

	<template v-if="selectedRoomsQty">
		<qit-select-room-guests v-for="(val,i) in selectedRoomsQty" :key="i"
			class="text__box"
			:title="$t('room') + ': ' + val"
			:room_id="room_id"
			:rate_id="rate_id"
			:max_room_qty="max_room_qty"
			:max_adults="max_adults"
			:children_on_bed="children_on_bed"
			:children_no_bed="children_no_bed"
			:num_nights="num_nights"
			:currency="currency"
			:precision="precision"
			v-model="innerValue[i]"
			@input="onInputDebounce"
			@delete="onDeleteRoom(i)"
		></qit-select-room-guests>
	</template>

</div>
`,
}
